import { createFileRoute } from "@tanstack/react-router";
import { OrganizationAdmin } from "@/components/Organizations/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const organizationId = params?.id;

  return <OrganizationAdmin organizationId={organizationId} />;
}

export const Route = createFileRoute("/_authenticated/accounts/$id/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
